var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app"},[_c('TheSidebar'),_c('CWrapper',[_c('TheHeader'),_c('div',{staticClass:"c-body"},[_c('main',{staticClass:"c-main"},[_c('CContainer',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1),_c('TheFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }